import Request from 'plugin-tigre-request'
import utils from '@/utils'
import crypto from 'crypto'
import UserAttributes from '@/helpers/UserAttributes'

const basePath = '/transport-co/users/invoices'
const itemsPath = '/transport-co/users/invoices/{0}/itens'

const defaultRequestParam = (path) => {
  return {
    ...utils.makeDefaultRequestData(),
    resource: `${path}`,
  }
}

const types = {
  DATA_TO_LIST: 'setDataToList',
  ITEMS_TO_LIST: 'setItemsToList',
  UPLOAD_RESPONSE: 'uploadResponse',
  FILTER: 'setFilter',
  CLEAR_STATE: 'clearState',
  CLEAR_ITEMS: 'clearItemsList',
}
export default {
  namespaced: true,
  state: {
    list: [],
    itemsList: [],
    message: '',
    filters: {},
  },
  getters: {
    getList(state) {
      return state.list
    },
    geItemstList(state) {
      return state.itemsList
    },
    getMessage(state) {
      return state.message
    },
    getListFilter(state) {
      let list = state.list
      const keys = Object.keys(state.filters)
      keys.forEach((key) => {
        if (key == 'documentCode') {
          list = list.filter((item) =>
            state.filters[key] != null && state.filters[key].length > 0 ? state.filters[key].includes(item[key]) : item
          )
        } else {
          list = list.filter((item) => (state.filters[key] != null ? item[key]?.includes(state.filters[key]) : item))
        }
      })

      return list
    },
    getFilter(state) {
      return state.filters
    },
  },
  mutations: {
    setDataToList(state, payload) {
      const { data, message } = payload
      state.list = data
      state.message = message || ''
    },
    setItemsToList(state, payload) {
      const { data } = payload
      state.itemsList = data
    },
    clearState(state, clearFilter = true) {
      state.list = []
      if (clearFilter) {
        state.filters = {}
      }
      state.itemsList = []
      state.message = ''
    },
    clearItemsList(state) {
      state.itemsList = []
    },
    setFilter(state, payload) {
      state.filters = payload
    },
  },
  actions: {
    setFilter({ commit }, data) {
      commit(types.FILTER, data)
    },
    async setDataToList({ commit }, data) {
      commit(types.FILTER, {})
      let queryParams = data
      let companyCode = data.companyCode
      const hashCache = crypto.createHash('md5').update(JSON.stringify(queryParams)).digest('hex')
      delete data.companyCode

      queryParams['cache-control'] = hashCache

      let requestParam = {
        ...utils.makeDefaultRequestMuleData(),
        data: queryParams,
        method: 'GET',
      }
      requestParam.headers['companyCode'] = companyCode
      requestParam.headers['e-mail'] = await UserAttributes('email')
      requestParam.headers['path'] = `/api${basePath}`
      requestParam.headers.common = { 'Access-Control-Allow-Origin': '*' }
      // Timeout do próprio Lambda URL Function
      requestParam.timeout = 84600 * 1000

      let response
      try {
        response = await Request(requestParam)
        commit(types.DATA_TO_LIST, {
          data: response.data.invoices || [],
          message: response.data.message || '',
          request: requestParam,
        })
      } catch (error) {
        if (error.response) {
          response = error.response.data[0] || error.response.data
        } else {
          response = error
        }
      }
      return response
    },
    async setItemsDataToList({ commit }, data) {
      let requestParam = {
        ...defaultRequestParam(itemsPath.replace('{0}', data)),
        method: 'GET',
      }
      let response
      try {
        response = await Request(requestParam)
        commit(types.ITEMS_TO_LIST, {
          data: response.data.items || [],
          request: requestParam,
        })
      } catch (error) {
        if (error.response) {
          response = error.response.data[0]
        } else {
          response = error
        }
      }
      return response
    },
    clearState({ commit }, data) {
      commit(types.CLEAR_STATE, data)
    },
    clearItemsList({ commit }) {
      commit(types.CLEAR_ITEMS)
    },
  },
}
